 <div class="mt-2 grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
  <div
    class="bg-card dark flex flex-auto flex-col overflow-hidden rounded-2xl shadow sm:col-span-2 lg:col-span-3">
    <div
      class="ml-10 mr-6 mt-10 flex items-center justify-between sm:mr-10">
      <div class="mx-6 flex items-start">
        <div
          class="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          <div class="flex flex-col">
            <div class="flex items-center">
              <div class="text-secondary font-medium leading-5">
                {{'TotalRevenue' | transloco}}
              </div>
            </div>
            <div class="mt-2 flex items-start">
              <div
                class="text-3xl font-bold leading-none tracking-tight">
                {{ data.totalRevenue | currency: 'CHF' }}
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="flex items-center">
              <div class="text-secondary font-medium leading-5">
                {{ 'TotalExpenses' | transloco }}
              </div>
            </div>
            <div class="mt-2 flex items-start">
              <div
                class="text-3xl font-bold leading-none tracking-tight">
                {{ data.totalExpenses | currency: 'CHF' }}
              </div>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="flex items-center">
              <div class="text-secondary font-medium leading-5">
                {{ 'Balance' | transloco}}
              </div>
            </div>
            <div class="mt-2 flex items-start">
              <div
                class="text-3xl font-bold leading-none tracking-tight">
                {{
                data.balance
                | currency: 'CHF'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-2">
        <mat-button-toggle-group
          class="hidden space-x-1 border-none sm:inline-flex"
          value="this-year"
          #visitorsYearSelector="matButtonToggleGroup">
          <mat-button-toggle
            class="overflow-hidden rounded-full border-none px-1.5 font-medium"
            value="last-year" (click)='setYear("last-year")'>{{'LastYear' |
            transloco}}
          </mat-button-toggle>
          <mat-button-toggle
            class="overflow-hidden rounded-full border-none px-1.5 font-medium"
            value="this-year" (click)='setYear("this-year")'>{{'ThisYear' |
            transloco}}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <div class="sm:hidden">
          <button
            mat-icon-button
            [matMenuTriggerFor]="visitorsMenu">
            <mat-icon
              [svgIcon]="
                                        'heroicons_outline:ellipsis-vertical'
                                    "></mat-icon>
          </button>
          <mat-menu #visitorsMenu="matMenu">
            <button mat-menu-item>{{'ThisYear' | transloco}}</button>
            <button mat-menu-item>{{'LastYear' | transloco}}</button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="flex h-80 flex-auto flex-col">
      <apx-chart
        class="h-full w-full flex-auto"
        [chart]="chartSummary.chart"
        [colors]="chartSummary.colors"
        [dataLabels]="chartSummary.dataLabels"
        [fill]="chartSummary.fill"
        [grid]="chartSummary.grid"
        [series]="
                            chartSummary.series
                        "
        [stroke]="chartSummary.stroke"
        [tooltip]="chartSummary.tooltip"
        [xaxis]="chartSummary.xaxis"
        [yaxis]="chartSummary.yaxis"></apx-chart>
    </div>
  </div>
  <!-- Conversions -->
  <div
    class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow sm:col-span-2 lg:col-span-1">
    <div class="m-6 mb-0 flex items-start justify-between">
      <div
        class="truncate text-lg font-medium leading-6 tracking-tight">
        {{'Completed' | transloco}}
      </div>
    </div>
    <div
      class="mx-6 mt-3 flex flex-col lg:flex-row lg:items-center">
      <div
        class="text-7xl font-bold leading-tight tracking-tighter">
        {{ data.totalCompleted }}
      </div>
      <div
        class="flex lg:ml-3 lg:flex-col"
        [ngClass]="completedTrend.up ? 'text-emerald-500' : 'text-rose-500'">

        <mat-icon
          class="icon-size-5"
          [svgIcon]="completedTrend.up
      ? 'heroicons_mini:arrow-trending-up'
      : 'heroicons_mini:arrow-trending-down'"
          [ngClass]="completedTrend.up ? 'text-emerald-500' : 'text-rose-500'">
        </mat-icon>

        <div
          class="text-secondary ml-1 flex items-center whitespace-nowrap text-md leading-none lg:ml-0 lg:mt-0.5">
          <span class="font-medium"
            [ngClass]="completedTrend.up ? 'text-emerald-500' : 'text-rose-500'">
            {{ completedTrend.percent }}%
          </span>
          <span class="ml-1">
            {{ (completedTrend.up ? 'AboveLastYear' :
            'BelowLastYear') | transloco }}
          </span>
        </div>
      </div>

    </div>
    <div class="flex h-20 flex-auto flex-col">
      <apx-chart
        class="h-full w-full flex-auto"
        [chart]="chartCompleted.chart"
        [colors]="chartCompleted.colors"
        [series]="chartCompleted.series"
        [stroke]="chartCompleted.stroke"
        [tooltip]="chartCompleted.tooltip"
        [xaxis]="chartCompleted.xaxis"
        [yaxis]="chartCompleted.yaxis"></apx-chart>
    </div>
  </div>
  <!-- Impressions -->
  <div
    class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow">
    <div class="m-6 mb-0 flex items-start justify-between">
      <div
        class="truncate text-lg font-medium leading-6 tracking-tight">
        {{'Delivered' | transloco}}
      </div>
    </div>
    <div
      class="mx-6 mt-3 flex flex-col lg:flex-row lg:items-center">
      <div
        class="text-7xl font-bold leading-tight tracking-tighter">
        {{ data.totalDelivered }}
      </div>
      <div
        class="flex lg:ml-3 lg:flex-col"
        [ngClass]="deliveredTrend.up ? 'text-emerald-500' : 'text-rose-500'">

        <mat-icon
          class="icon-size-5"
          [svgIcon]="deliveredTrend.up
      ? 'heroicons_mini:arrow-trending-up'
      : 'heroicons_mini:arrow-trending-down'"
          [ngClass]="deliveredTrend.up ? 'text-emerald-500' : 'text-rose-500'">
        </mat-icon>

        <div
          class="text-secondary ml-1 flex items-center whitespace-nowrap text-md leading-none lg:ml-0 lg:mt-0.5">
          <span class="font-medium"
            [ngClass]="deliveredTrend.up ? 'text-emerald-500' : 'text-rose-500'">
            {{ deliveredTrend.percent }}%
          </span>
          <span class="ml-1">
            {{ (deliveredTrend.up ? 'AboveLastYear' : 'BelowLastYear') | transloco
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex h-20 flex-auto flex-col">
      <apx-chart
        class="h-full w-full flex-auto"
        [chart]="chartDelivered.chart"
        [colors]="chartDelivered.colors"
        [series]="chartDelivered.series"
        [stroke]="chartDelivered.stroke"
        [tooltip]="chartDelivered.tooltip"
        [xaxis]="chartDelivered.xaxis"
        [yaxis]="chartDelivered.yaxis"></apx-chart>
    </div>
  </div>
  <!-- Visits -->
  <div
    class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow">
    <div class="m-6 mb-0 flex items-start justify-between">
      <div
        class="truncate text-lg font-medium leading-6 tracking-tight">
        {{'Accounted' | transloco}}
      </div>
    </div>
    <div
      class="mx-6 mt-3 flex flex-col lg:flex-row lg:items-center">
      <div
        class="text-7xl font-bold leading-tight tracking-tighter">
        {{ data.totalAccounted }}
      </div>
      <div
        class="flex lg:ml-3 lg:flex-col"
        [ngClass]="accountedTrend.up ? 'text-emerald-500' : 'text-rose-500'">

        <mat-icon
          class="icon-size-5"
          [svgIcon]="accountedTrend.up
      ? 'heroicons_mini:arrow-trending-up'
      : 'heroicons_mini:arrow-trending-down'"
          [ngClass]="accountedTrend.up ? 'text-emerald-500' : 'text-rose-500'">
        </mat-icon>

        <div
          class="text-secondary ml-1 flex items-center whitespace-nowrap text-md leading-none lg:ml-0 lg:mt-0.5">
          <span class="font-medium"
            [ngClass]="accountedTrend.up ? 'text-emerald-500' : 'text-rose-500'">
            {{ accountedTrend.percent }}%
          </span>
          <span class="ml-1">
            {{ (accountedTrend.up ? 'AboveLastYear' : 'BelowLastYear') | transloco
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex h-20 flex-auto flex-col">
      <apx-chart
        class="h-full w-full flex-auto"
        [chart]="chartAccounted.chart"
        [colors]="chartAccounted.colors"
        [series]="chartAccounted.series"
        [stroke]="chartAccounted.stroke"
        [tooltip]="chartAccounted.tooltip"
        [xaxis]="chartAccounted.xaxis"
        [yaxis]="chartAccounted.yaxis"></apx-chart>
    </div>
  </div>
</div>

